import { Button, Modal } from '@ver-uds/react';
import { Alert, ButtonGroup, TextAreaControl } from '@ver-uds/uswds-react';
import classNames from 'classnames';
import React from 'react';
import { useForm } from 'react-hook-form';

export interface MouRejectonModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  onSubmit: (data: { reason: string }) => Promise<void>;
  isLoading: boolean;
  isError: boolean;
}

export const ClientMouRejectionModal = ({
  open,
  setOpen,
  onSubmit,
  isLoading,
  isError,
}: MouRejectonModalProps): JSX.Element => {
  // eslint-disable-next-line @typescript-eslint/unbound-method
  const { errors, register, handleSubmit } = useForm<{ reason: string }>();

  return (
    <Modal
      header="Are you sure you want to decline the MOU?"
      id="reject-mou-modal"
      open={open}
      close={() => setOpen(false)}
    >
      <Modal.Content>
        <p>
          We’ll notify the user who requested your approval for the MOU. You’ll be redirected to the E-Verify home page
          if you choose to continue.
        </p>
        <form id="reject-mou-form" noValidate onSubmit={handleSubmit(onSubmit)}>
          <TextAreaControl
            name="reason"
            id="reject-mou-reason"
            label="Reason for Declining MOU"
            ref={register({ maxLength: { value: 100, message: 'Please enter fewer than 100 characters' } })}
            characterCountMax={100}
            maxLength={100}
            errorMessage={errors?.reason?.message}
          />
        </form>
        {isError ? (
          <Alert status="error" className="margin-top-4">
            <Alert.Heading>We were unable to process your request</Alert.Heading>
            <Alert.Text>
              There is an issue with your Electronic MOU link. Please contact your agent to send you a new one.
            </Alert.Text>
          </Alert>
        ) : null}
      </Modal.Content>
      <Modal.Footer
        className={classNames('display-flex flex-row flex-justify-end', {
          'display-none': isError,
        })}
      >
        <ButtonGroup>
          <Button variant="secondary" type="button" onClick={() => setOpen(false)}>
            Cancel
          </Button>
          <Button variant="destructive" type="submit" form="reject-mou-form" disabled={isLoading}>
            Decline MOU
          </Button>
        </ButtonGroup>
      </Modal.Footer>
    </Modal>
  );
};

export default ClientMouRejectionModal;
